export const AddProApi = Symbol.for('AddProApi');

/**
 * Add Pro API
 * 处理 Pro 套餐权限添加相关的接口调用
 */
export interface AddProApi {
    /**
     * 添加 Pro 套餐权限
     */
    addProPkg(): Promise<void>;
}
